import { clamp, isDefined, Option } from "@opendaw/lib-std";
import { MidiKeys } from "@opendaw/lib-dsp";
export var CubedPatternData;
(function (CubedPatternData) {
    CubedPatternData.MaxSteps = 64;
    CubedPatternData.Type = "cubed-pattern";
    CubedPatternData.Version = 1;
    /** Accepts `60`, `C3` or `C#3`. The octave offset matches MidiKeys.toFullString. */
    CubedPatternData.parseNote = (text) => {
        const trimmed = text.trim();
        if (/^\d+$/.test(trimmed)) {
            const value = parseInt(trimmed, 10);
            return value >= 0 && value <= 127 ? Option.wrap(value) : Option.None;
        }
        const match = trimmed.match(/^([A-Ga-g])([#b]?)(-?\d+)$/);
        if (match === null) {
            return Option.None;
        }
        const bases = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
        const accidental = match[2] === "#" ? 1 : match[2] === "b" ? -1 : 0;
        const note = bases[match[1].toUpperCase()] + accidental + (parseInt(match[3], 10) + 2) * 12;
        return note >= 0 && note <= 127 ? Option.wrap(note) : Option.None;
    };
    CubedPatternData.toJSON = ({ length, steps }) => JSON.stringify({
        type: CubedPatternData.Type,
        version: CubedPatternData.Version,
        length,
        steps: steps.map(({ note, active, slide, accent }) => ({
            note: MidiKeys.toFullString(note), gate: active, slide, accent
        }))
    }, null, 2);
    CubedPatternData.fromJSON = (text) => Option.tryCatch(() => JSON.parse(text)).flatMap(readObject);
    const readNote = (value) => {
        if (typeof value === "number" && Number.isFinite(value)) {
            return Option.wrap(clamp(Math.round(value), 0, 127));
        }
        return typeof value === "string" ? CubedPatternData.parseNote(value) : Option.None;
    };
    const readFlag = (value) => value === true;
    const readStep = (value) => {
        if (typeof value !== "object" || value === null) {
            return Option.None;
        }
        const source = value;
        return readNote(source.note).map(note => ({
            note,
            active: readFlag(isDefined(source.gate) ? source.gate : source.active),
            slide: readFlag(source.slide),
            accent: readFlag(source.accent)
        }));
    };
    const readObject = (value) => {
        if (typeof value !== "object" || value === null) {
            return Option.None;
        }
        const source = value;
        if (isDefined(source.type) && source.type !== CubedPatternData.Type) {
            return Option.None;
        }
        if (!Array.isArray(source.steps)) {
            return Option.None;
        }
        const steps = source.steps.slice(0, CubedPatternData.MaxSteps).map(readStep);
        if (steps.some(step => step.isEmpty())) {
            return Option.None;
        }
        if (steps.length === 0) {
            return Option.None;
        }
        const length = typeof source.length === "number" && Number.isFinite(source.length)
            ? clamp(Math.round(source.length), 1, steps.length)
            : steps.length;
        return Option.wrap({ length, steps: steps.map(step => step.unwrap()) });
    };
})(CubedPatternData || (CubedPatternData = {}));
